import React from 'react'
import { Selector } from 'antd-mobile'
import { TravelCategory } from '@/types'
import { useIsMobile } from '@/hooks/useIsMobile'

interface TravelCategorySelectorProps {
  value: TravelCategory | null
  onChange: (category: TravelCategory) => void
  disabled?: boolean
}

const TravelCategorySelectorResponsive: React.FC<TravelCategorySelectorProps> = ({ value, onChange, disabled }) => {
  const isMobile = useIsMobile()

  React.useEffect(() => {
    if (!value) {
      onChange('CROSS_CITY')
    }
  }, [value, onChange])

  // 移动端：antd-mobile Selector
  if (isMobile) {
    const current = value || 'CROSS_CITY'
    const options = [
      { label: '跨城', value: 'CROSS_CITY' },
      { label: '同城', value: 'LOCAL' },
    ]
    return (
      <div>
        <label className="heading-2 mb-clay-sm block">选择类别 <span className="text-red-500">*</span></label>
        <Selector
          options={options}
          value={[current]}
          disabled={disabled}
          onChange={(arr) => {
            if (!disabled && arr.length > 0) onChange(arr[0] as TravelCategory)
          }}
        />
        <p className="hint-text mt-2">
          {current === 'LOCAL'
            ? '同城：在同一城市内的短期外出，仅限城市主城区'
            : '跨城：跨城市的出差，支持多段行程'}
        </p>
      </div>
    )
  }

  // PC端：保持原有 claymorphism 风格
  return (
    <div>
      <label className="heading-2 mb-clay-sm block">选择类别 <span className="text-red-500">*</span></label>
      <div className="required-field">
        <select
          className="clay-input w-full appearance-none"
          value={value || 'CROSS_CITY'}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value as TravelCategory)}
        >
          <option value="CROSS_CITY">跨城</option>
          <option value="LOCAL">同城</option>
        </select>
      </div>
      <p className="hint-text mt-2">
        {value === 'LOCAL'
          ? '同城：在同一城市内的短期外出，仅限城市主城区'
          : '跨城：跨城市的出差，支持多段行程'}
      </p>
    </div>
  )
}

export default TravelCategorySelectorResponsive
